import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductBadges extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * Updates the badges when the variant changes.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector('product-badges');

    if (!newBadges) return;

    morph(this, newBadges, { childrenOnly: true });
  };
}

if (!customElements.get('product-badges')) {
  customElements.define('product-badges', ProductBadges);
}
